import React from "react";
import { BrowserRouter } from "react-router-dom";
import Context from "src/hooks/context";

import SSO from "src/pages/sso";
import Router from "src/router";

function App() {
  return (
    <BrowserRouter>
      {window.location.pathname === "/callback" ? (
        <SSO />
      ) : (
        <Context>
          <Router />
        </Context>
      )}
    </BrowserRouter>
  );
}

export default App;
